import config from '../../../config/config';
import {fork, put, takeEvery, all} from 'redux-saga/effects';
import { getErrorMessage } from "../../../utils/serverErrorCheck";
import { LogControllerDtoGoogleStorePurchaseLogListRequest, LogControllerDtoGoogleStorePurchaseLogListResponse, PerplayLogApi } from "../../models/src";
import { GOOGLE_STORE_PURCHASE_LOG_LIST_REQUEST } from "../../constants/log/googleStorePurchaseLogContstants";
import {googleStorePurchaseLogList, setTotalCount, setGoogleStorePurchaseLogPagination} from "../../actions/log/googleStorePurchaseLogActions";

const api = new PerplayLogApi(config.API_CLIENT);

function* googleStorePurchaseLogSaga(payload) {
    console.log("googleStorePurchaseLogSaga called");
    console.assert(payload.callback, {
        message: "callback이 설정되지 않았습니다.",
    });

    try{
        const requestData = new LogControllerDtoGoogleStorePurchaseLogListRequest();
        requestData.page = payload.page;
        requestData.pageLength = payload.pageLength;
        requestData.beginDate = payload.beginDate;
        requestData.endDate = payload.endDate;
        requestData.accountNo = payload.accountNo;
        requestData.productNo = payload.productNo;
        requestData.productId = payload.productId;
        requestData.orderId = payload.orderId;
        requestData.purchaseToken = payload.purchaseToken;
        console.log(`requestData : `);
        console.log(requestData);

        const result = yield api.apiPerplayLogGoogleStorePurchaseLogListPost({logControllerDtoGoogleStorePurchaseLogListRequest: requestData}, () => {
        });
        const data = api.apiClient.deserialize(result, LogControllerDtoGoogleStorePurchaseLogListResponse);

        console.log("data :");
        console.log(data);

        if(data.resultCode !== 200){
            throw new Error(getErrorMessage(data));
        }

        yield put(googleStorePurchaseLogList(data.list));
        yield put(setTotalCount(data.totalCount));
        yield put(setGoogleStorePurchaseLogPagination(
            payload.page,
            data.totalCount,
            payload.beginDate,
            payload.endDate,
        ));

        payload.callback(data);
    }catch(error) {
        payload.error(error);
    }
}

function* googleStorePurchaseLogRootSaga() {
    yield all([
        takeEvery(GOOGLE_STORE_PURCHASE_LOG_LIST_REQUEST, googleStorePurchaseLogSaga),
    ]);
}

const googleStorePurchaseLogSagas = [fork(googleStorePurchaseLogRootSaga)];

export default googleStorePurchaseLogSagas;